import { format } from "date-fns";

export const fmtDate = (iso) => {
  if (!iso) return "-";
  try {
    return format(new Date(iso), "dd/MM/yyyy");
  } catch {
    return "-";
  }
};

// "20 May 2026" — for All Orders / MIS displays
export const fmtDateLong = (iso) => {
  if (!iso) return "-";
  try {
    return format(new Date(iso), "dd MMM yyyy");
  } catch {
    return "-";
  }
};

// "20 May 2026 • 06:17 PM"
export const fmtDateTimeLong = (iso) => {
  if (!iso) return "-";
  try {
    return format(new Date(iso), "dd MMM yyyy • hh:mm a");
  } catch {
    return "-";
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "-";
  try {
    return format(new Date(iso), "dd/MM/yyyy hh:mm a");
  } catch {
    return "-";
  }
};

export const todayISO = () => format(new Date(), "yyyy-MM-dd");

export const daysBetween = (iso1, iso2) => {
  if (!iso1 || !iso2) return 0;
  try {
    const d1 = new Date(iso1);
    const d2 = new Date(iso2);
    return Math.floor((d2 - d1) / (1000 * 60 * 60 * 24));
  } catch {
    return 0;
  }
};

export const ROLE_LABELS = {
  spare_executive: "Parts Executive",
  parts_manager: "Parts Manager",
  crm: "CRM",
  admin: "Admin",
  floor_supervisor: "Floor Supervisor",
  works_manager: "Works Manager",
  billing_team: "Billing Team",
  service_advisor: "Service Advisor",
  workshop_manager: "Workshop Manager",
  service_manager: "Service Manager",
  security: "Security",
};

export const STATUS_LABELS = {
  draft: "Draft",
  new_order: "New Order",
  ordered: "Ordered",
  partially_received: "Partially Received",
  pending_pickup: "Pending Pickup",
  invoiced: "Completed",
  cancelled: "Cancelled",
  returned_to_stock: "Returned To Stock",
  customer_not_responding: "Customer Not Responding",
  unclaimed: "Unclaimed",
};

export const STATUS_COLORS = {
  draft: "bg-slate-100 text-slate-700",
  new_order: "bg-blue-100 text-blue-800",
  ordered: "bg-amber-100 text-amber-800",
  partially_received: "bg-orange-100 text-orange-800",
  pending_pickup: "bg-emerald-100 text-emerald-800",
  invoiced: "bg-green-100 text-green-900",
  cancelled: "bg-rose-100 text-rose-800",
  returned_to_stock: "bg-zinc-200 text-zinc-700",
  customer_not_responding: "bg-purple-100 text-purple-800",
  unclaimed: "bg-fuchsia-100 text-fuchsia-800",
};

export const PRIORITY_COLORS = {
  normal: "bg-slate-100 text-slate-700",
  urgent: "bg-red-100 text-red-700",
};
